import { PayloadAction } from '@reduxjs/toolkit'
import { IRequestByPartnerId } from 'legacy/lut/classes/models/service'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { IAttachment } from 'clickNgo/models/file'

import { IPartnerState } from '../models'

export const getPartnerFilesByIdPending = (
  state: IPartnerState,
  action: PayloadAction<undefined, string, { arg: IRequestByPartnerId }>
) => {
  const { meta } = action
  const status = RequestStatus.PENDING
  const message = `Files is loading for ${meta.arg}`

  state.partnerFiles.meta = meta
  state.partnerFiles.message = message
  state.partnerFiles.status = status
}

export const getPartnerFilesByIdRejected = (
  state: IPartnerState,
  action: PayloadAction<unknown, string, { arg: IRequestByPartnerId }>
) => {
  const { meta } = action
  const status = RequestStatus.REJECTED
  const message = `Files loading is failed for ${meta.arg}`

  state.partnerFiles.meta = meta
  state.partnerFiles.message = message
  state.partnerFiles.status = status
}

export const getPartnerFilesByIdFulfilled = (
  state: IPartnerState,
  action: PayloadAction<IAttachment[], string, { arg: IRequestByPartnerId }>
) => {
  const { meta, payload: data } = action
  const status = RequestStatus.FULFILLED
  const message = `success`

  state.partnerFiles = {
    meta,
    status,
    message,
    data,
  }
}
